import { forwardRef, useImperativeHandle, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  InputGroup,
  Input,
  InputLeftAddon
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { Button } from '../../../../../../components/Button';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

const schema = z.object({
  codigo_tc: z.string().nonempty('Código da transportadora é obrigatório')
});

export const CodigoTransportadoraCliente = forwardRef(({ onSave, ...props }, ref) => {
  const [open, setOpen] = useState(false);
  const { register, handleSubmit } = useForm({
    resolver: zodResolver(schema)
  });

  useImperativeHandle(ref, () => ({
    openModal: () => {
      setOpen(true);
    }
  }));

  async function onSaveTc(data) {
    await onSave({ codigo_tc: data.codigo_tc });
  }

  return (
    <>
      <Modal isOpen={open} onClose={() => setOpen(false)} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Transportadora Cliente</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <InputGroup>
              <InputLeftAddon children="Código" />
              <Input
                borderRadius="0"
                placeholder="digite o código da transportadora"
                {...register('codigo_tc')}
              />
            </InputGroup>
          </ModalBody>
          <ModalFooter>
            <Button bgColor="red.500" mr={3} onClick={() => setOpen(false)}>
              Fechar
            </Button>
            <Button
              colorScheme="green"
              onClick={handleSubmit(onSaveTc)}
              isLoading={props.isLoading}>
              Salvar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
});
